<script setup>
import { ref } from "vue";
import { VueFinalModal } from "vue-final-modal";

import SVGIcon from "@/components/SVGIcon.vue";
import PlayButton from "@/components/redesign/PlayButton/PlayButton.vue";

defineProps({
  image: { type: String, default: "" },
  alt: { type: String, default: "" },
  video: { type: String, default: "" },
  description: { type: String, default: "" },
  title: { type: String, default: "" },
  tiny: { type: Boolean, default: false },
  light: { type: Boolean, default: false },
  fullWidth: { type: Boolean, default: false },
  vertical: { type: Boolean, default: false },
});

const isModalOpened = ref(false);

const toggleVideo = (open) => () => {
  isModalOpened.value = open;
};

const openVideo = toggleVideo(true);
const closeVideo = toggleVideo(false);
</script>

<template>
  <div
    class="video-card-wrapper"
    :class="{ light }"
    :style="fullWidth && { width: '100%' }"
  >
    <div class="video-card" :class="{ tiny }" @click="openVideo">
      <div class="image-container">
        <imgix class="image" :src="image" :alt="alt" />
      </div>
      <div v-if="!tiny" class="shadow"></div>
      <div class="description-container">
        <play-button :large="!tiny"></play-button>
        <template v-if="!tiny">
          <span v-if="title" class="title r-h4-to-h2">{{ title }}</span>
          <p v-if="description" class="description r-body-small-to-large">
            {{ description }}
          </p>
        </template>
      </div>
    </div>

    <div v-if="tiny" class="tiny-description">
      <span v-if="title" class="h6">{{ title }}</span>
      <p v-if="description" class="description body-small">
        {{ description }}
      </p>
    </div>
  </div>

  <VueFinalModal
    v-if="isModalOpened"
    v-model="isModalOpened"
    classes="modal-container"
    content-class="modal-content"
    @click="closeVideo"
  >
    <div class="modal-content-wrapper">
      <a class="modal-close" :class="vertical ? 'vertical' : ''">
        <SVGIcon name="close-small" class="modal-close-icon" />
      </a>
      <iframe
        :src="video"
        class="video"
        :class="vertical ? 'vertical' : ''"
        allow="autoplay"
      ></iframe>
    </div>
  </VueFinalModal>
</template>

<style scoped src="./style.scss" lang="scss" />
